import cn from 'classnames';
import React, { FC, memo } from 'react';

import { getDexScreenerFarmIcon } from '@utils/logo.utils';

import { TokenSize } from '@constants/common/ui.constants';

import useStyles from './styles.module';

interface Props {
  className?: string;
  size?: TokenSize;
  dexscreenerChainId: string;
  address: string;
}

const DexScreenerTokenIcon: FC<Props> = ({
  dexscreenerChainId,
  address,
  size = TokenSize.Medium,
  className = '',
}) => {
  const { classes } = useStyles({ size });

  return (
    <img
      className={cn(classes.avatar, className)}
      src={
        getDexScreenerFarmIcon(dexscreenerChainId, address) ||
        'https://dexfi.com/icons/unknownLogo.png'
      }
      alt="pairSymbol"
      onError={(e) => {
        e.currentTarget.src = 'https://dexfi.com/icons/unknownLogo.png';
      }}
    />
  );
};

export default memo(DexScreenerTokenIcon);
